<div class="qb-flex-check-challenge qb-fd-coloumn qb-h-100" [ngClass]="{'cursor-notallowed':status=='ACTIVE' }">
  <div class="qb-header-container">
    <div class="qb-header-text-challenge">Reward Details</div>
    <div class="qb-description-challenge">
      After Completing the level customer gets these rewards
    </div>
  </div>
  <div class="qb-get-data-container">
    <div class="qb-get-data-wrapper qb-h-100"   >
      <div *ngFor="let reward of rewardTypes" [ngClass]="{'pointerevents-none':status=='ACTIVE' }" >
        <div class="qb-flex-check-challenge qb-w-350">
          <mat-checkbox
            class="margin-left-10"
            color="primary"
            [(ngModel)]="selectedRewards[reward.type]"
          >
          </mat-checkbox>
          <div class="reward-info">
            <h5>{{ reward.displayName }}</h5>
            <p>{{ reward.description }}</p>
          </div>
        </div>
        <div *ngIf="reward.type === 'LOYALTY_POINTS' && selectedRewards[reward.type]">
          <div class="qb-d-flex qb-fd-coloumn qb-w-25 qb-ml-25">
            <div class="qb-heading-reward-data">Number Of Coins</div>
            <div class="formDiv">
              <input
                type="number"
                class="formInput"
                maxlength="10"
                (keydown)="stringInputKeyDown($event, 10)"
                min="0"
                [(ngModel)]="numberOfCoins"
              />
            </div>
            <div>
              <span
                style="color: var(--main-font-red); font-size: 12px"
                id="numberOfCoinsErrorField"
              ></span>
            </div>
          </div>
        </div>
        <div *ngIf="reward.type === 'BADGE' && selectedRewards[reward.type]">
          <div class="qb-d-flex qb-fd-coloumn qb-w-25 qb-ml-25">
            <app-milestone-common-check-box
              #badgeSelection
              [isEdit]="isEdit"
              [selected] = "badgeSelected"
              [dataList]="badgeList"
              [type]="'Badge'"
              (dataSelected)="badgeSelectedEvent($event)"
            ></app-milestone-common-check-box>
          </div>
          <div class="left-align-text-err qb-ml-25">
            <span
              style="color: var(--main-font-red); font-size: 12px"
              id="badgeErrorField"
            ></span>
          </div>
        </div>
        <div *ngIf="reward.type === 'OFFER' && selectedRewards[reward.type]">
          <div class="qb-d-flex qb-fd-coloumn qb-w-25 qb-ml-25">
            <app-milestone-common-check-box
              #offerSelection
              [isEdit]="isEdit"
              [selected] = "offerSelected"
              [dataList]="offerList"
              [type]="'Offer'"
              (dataSelected)="offerSelectedEvent($event)"
            ></app-milestone-common-check-box>
          </div>
          <div class="left-align-text-err qb-ml-25">
            <span
              style="color: var(--main-font-red); font-size: 12px"
              id="offerErrorField"
            ></span>
          </div>
        </div>
      </div>
    </div>
    <div class="qb-button-container-challenge-selection">
      <div class="secondary-button" (click)="selectChallengeType('exit')">
        Save and Exit
      </div>
      <div class="primary-button" (click)="selectChallengeType('summary')" *ngIf="!isEdit">
        Create
      </div>
      <div class="primary-button" (click)="selectChallengeType('summary')" *ngIf="isEdit">
        Save
      </div>
    </div>
  </div>
</div>
